export const MEMORY_PATH_NAME = 'memory';

export const MEMORY_CREATION_METHOD_METADATA_KEY = 'creation_method';
export const MEMORY_STATUS_METADATA_KEY = 'status';

export const MEMORY_MANUAL_CREATION_METADATA = {
  [MEMORY_CREATION_METHOD_METADATA_KEY]: { stringValue: 'manual' as const },
  [MEMORY_STATUS_METADATA_KEY]: { stringValue: 'active' as const },
};

export const MEMORY_AUTOMATIC_CREATION_METADATA = {
  [MEMORY_CREATION_METHOD_METADATA_KEY]: { stringValue: 'automatic' as const },
  [MEMORY_STATUS_METADATA_KEY]: { stringValue: 'active' as const },
};
